import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Stack,
  Container,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";
import Scrollbar from "../components/scrollbar";
import TicketTransactionsTable from "src/components/transactions-table/TicketTransactionsTable";
import { get } from "src/utils/networkUtils";
import useWithUrlTenant from "src/hooks/useTenant";

export default function TicketTransactionsPage() {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState(null);

  const withTenant = useWithUrlTenant();

  useEffect(() => {
    setLoading(true);
    get(withTenant(`/admin/tickets/transactions`)).then(function (response) {
      setRows(response.transactions);
      setLoading(false);
    });
  }, [withTenant]);

  return (
    <>
      <Helmet>
        <title> Ticket Transactions </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Ticket Transactions
          </Typography>
        </Stack>

        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TicketTransactionsTable transactions={rows} />
            </Scrollbar>
          )}
        </Card>
      </Container>
    </>
  );
}
